namespace $.$$ {

	export class $shm_hitalama_map_overlayed extends $.$shm_hitalama_map_overlayed {

		map() {
			const entity = this.entity()
			return entity ? entity.cast( $shm_hitalama_map ) : null as any
		}

		auto() {
			if( !this.entity() ) return []
			return super.auto()
		}

		sub() {
			return this.entity() ? super.sub() : []
		}
		
		@ $mol_mem
		pointerdown_handler() {
			return $mol_wire_async( ( event: PointerEvent ) => {
				const id = (event.target as any)?.id
				if( !id?.includes('Overlayed_map') ) {
					this.Map_page().deselect_all()
				}
			} )
		}

		@ $mol_mem
		pointermove_handler() {
			return $mol_wire_async( ( event: PointerEvent ) => {
				this.Pane().pointer_client_pos( [ event.clientX, event.clientY ] )
			} )
		}

		Pane() {
			const obj = super.Pane()
			obj.plugins = ()=> []
			obj.zoom = ()=> 1
			obj.shift = () => new this.$.$mol_vector_2d(0,0)
			return obj
		}

		tool_mode( next?: string ) {
			return ''
		}

		selected( link: $giper_baza_link, next?: boolean ): boolean {
			return false
		}

		widget_tools_hidden() {
			return true
		}

		back_event_pointerdown( event: PointerEvent ) {
		}

		back_event_contextmenu( event: PointerEvent ) {
		}

		widget_event_contextmenu( ref: $giper_baza_link, event?: PointerEvent ) {
		}

		@ $mol_action
		event_drop( event: DragEvent ) {
			event.preventDefault()
		}

		@ $mol_mem
		keydown_handler_nopassive() {
			return $mol_wire_async( ( event: KeyboardEvent ) => {} )
		}

		@ $mol_mem
		paste_handler() {
			return $mol_wire_async( ( event: ClipboardEvent ) => {} )
		}

	}

}
